<template>
  <div class="DrkWhite pa-4">
      <h2 class="subheading green--text">Renewal Schedules</h2>
      <v-card class="mt-4">
      <Renewal/>
  </v-card>
  </div>
</template>

<script>
import Renewal from '@/components/Utils/Renewal.vue'
  export default {
    components: {
      Renewal
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>